// external imports
import React from 'react'
import PropTypes from 'prop-types'

const geocoder = new google.maps.Geocoder()

class Map extends React.Component {
    _markers = []

    state = {
        mounted: false
    }

    componentDidMount() {
        // grab a local copy of the config as props
        const config = { ...this.props }
        Reflect.deleteProperty(config, 'style')

        // create the map instance
        this._map = new google.maps.Map(this._element, {
            ...config
        })

        // for each marker we have to register
        for (const marker of this._markers) {
            // add it to the map
            this._addMarker(marker)
        }

        this.setState({ mounted: true })
    }

    getChildContext = () => ({
        registerMarker: this._registerMarker
    })

    _addMarker = location =>
        new google.maps.Marker({
            map: this._map,
            ...location
        })

    _registerMarker = data => {
        if (this.state.mounted) {
            this._addMarker(data)
        } else {
            this._markers.push(data)
        }
    }

    render() {
        // grab the used props
        const { style, ...unused } = this.props

        // render a div that we will populate
        return <div style={style} {...this.props} ref={ele => (this._element = ele)} />
    }
}

Map.childContextTypes = {
    registerMarker: PropTypes.func
}

export default Map



// WEBPACK FOOTER //
// ./src/components/maps/Map.js